export const PARSE_CONFIG = {
    workType: 'employment.employmentType',
    workPlace: 'employment.employerName',
    workPhone: 'employment.employerPhone',
    workAdditionalPhone: 'employment.additionalPhone',
    additionalIncome: 'employment.additionalIncomeAmount'
};


export const BLOCKS_CONFIG = [
    {
        name: 'workInfo',
        fields: ['workType', 'workPlace', 'workPhone', 'workAdditionalPhone'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'additionalIncome',
        fields: ['additionalIncome'],
        confirmed: false,
        filledCount: 0
    }
];
